import React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

import Button from '@mui/material/Button';
import get from 'lodash/get';

import { useCopyStringToClipboard } from '@src/hooks/use-copy-string-to-clipboard';

const TextCopyField = ({ source, title = 'Copy' }) => {
    const record = useRecordContext();
    const value = get(record, source);
    const copyCallback = useCopyStringToClipboard(value);

    if (!value) return null;

    return (
        <Button
            size="small"
            color="primary"
            onClick={copyCallback}
        >
            { title }
        </Button>
    );
};

TextCopyField.propTypes = {
    source: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default React.memo(TextCopyField);
